import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { PostUser, ShortLikeUser } from '../../../../interfaces';
import { GuestAuthService, CommunityMobileEventsService } from '../../../../services';
import { ExternalPostNavigationService } from '../../../../services/navigation/external-post-navigation.service';

@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationsComponent {
  likedBy = input<ShortLikeUser[]>([]);
  postOwner = input<PostUser>();
  postUuid = input.required<string>();
  isGuest = input.required<boolean>();
  isMajiApp = input.required<boolean>();
  isPostMaji = input.required<boolean>();
  variant = input.required<string>();

  openGuestView = output<void>();
  openRecommendedUsersDialogEvent = output<void>();

  private guestAuthService = inject(GuestAuthService);
  private mobileEventsService = inject(CommunityMobileEventsService);
  private externalPostNavService = inject(ExternalPostNavigationService);

  sortedLikedBy = computed(() => this.getSortedLikedByList(this.likedBy(), this.postOwner()));

  openFollowersModal(): void {
    if (this.isGuest()) {
      this.guestAuthService.handleGuestAuth({
        onCommunityInApp: () => this.openGuestView.emit(),
      });
      return;
    }

    const majiWebView = this.isMajiApp() && this.mobileEventsService.isWebView;

    if (majiWebView && this.isPostMaji()) {
      this.mobileEventsService.openRecommendedUsersByPost({
        postId: this.postUuid(),
        postOwner: this.postOwner(),
      });
      return;
    }

    this.openRecommendedUsersDialogEvent.emit();
  }

  private getSortedLikedByList(likedBy: ShortLikeUser[], postOwner: PostUser | undefined): ShortLikeUser[] {
    if (!postOwner) {
      return likedBy;
    }

    const filteredLikedBy = likedBy.filter(user => user.passport_uuid !== postOwner.user_uuid);

    const postOwnerAsShortLike = this.mapPostUserToShortLike(postOwner);

    return [postOwnerAsShortLike, ...filteredLikedBy];
  }

  private mapPostUserToShortLike(user: PostUser): ShortLikeUser {
    return {
      passport_uuid: user.user_uuid,
      username: user.username,
      avatar_url: this.externalPostNavService.getUserLogoUrl(user.user_logo) || user.avatar_url || '',
    };
  }
}
